import { render } from "./AwardDetailMay2019Page.vue?vue&type=template&id=a7c97336"
import script from "./AwardDetailMay2019Page.vue?vue&type=script&lang=js"
export * from "./AwardDetailMay2019Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__